export default __webpack_public_path__ + "static/media/graduated.1e66cdb3.svg";